import { CellContext, CellData } from "@tanstack/react-table"
import { useContext } from "react"

import { useEvent } from "shared/lib/useEvent"

import { Team } from "entities/teams/types/Team"

import { TeamListTableFeatures } from "./TeamListTableFeatures"
import { TeamListViewContext } from "./TeamListViewContext"

export function TeamListCell<T extends CellData>({
  info,
  children
}: {
  info: CellContext<TeamListTableFeatures, Team, T>
  children: React.ReactNode
}) {
  const { getTeamHref, onTeamSelect } = useContext(TeamListViewContext)

  const onClick = useEvent((e: React.MouseEvent) => {
    e.preventDefault()
    onTeamSelect(info.row.original)
  })

  // Every cell is a real anchor so the whole row is a click target. The extra
  // cells previously carried role="presentation" tabIndex={-1} to keep them out
  // of the reading order, but `presentation` is not an allowed role on an anchor
  // with href and conflicts with being focusable. A plain anchor is valid and
  // stays keyboard reachable; the duplicate links all point at the same team.
  return (
    <a
      className="anchor p-2 team-list__cell-content"
      href={getTeamHref(info.row.original)}
      onClick={onClick}
    >
      {children}
    </a>
  )
}
